// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2434":"364d8907","5733":"562e3a5a","6661":"6356f509"}[chunkId] + ".css";
};